import styles from "./VideoMenu.module.css";
import {createStyles, Fab, makeStyles} from "@material-ui/core";
import Menu, {SubMenu, Item as MenuItem} from "rc-menu";
import React, {useState, useCallback, memo, useMemo} from "react";
import PlaylistAddIcon from "@material-ui/icons/PlaylistAdd";
import "./rc-menu.css";
import {useSelector} from "react-redux";
import {AppState} from "../../../root/RootReducer";
import {isAdmin, isPresenter} from "../../../user/User";
import PuiMessage from "../../../components/widgets/PuiMessage";
import useResponsive from "../../../common/useResponsive";
import {useQuery} from "@tanstack/react-query";
import {ProgramDetail} from "src/stores/program/model/Program";
import {Video} from "src/common/video/models/Video";
import ProgramApi from "src/stores/program/ProgramApi";
import {queryClient} from "src/react-query";
interface VideoMenuProps {
    videoId: number;
    setMsg: (msg: string) => void;
}

const useStyles = makeStyles(() =>
    createStyles({
        icon: {
            marginLeft: "5px",
            marginTop: "5px",
            backgroundColor: "rgb(255, 255, 255, 0.7)",
            "&:hover": {
                backgroundColor: "rgb(255, 255, 255, 0.9)"
            }
        }
    })
);

function VideoMenu({
    videoId,
    setMsg
}: VideoMenuProps) {

    const classes = useStyles();

    const {userInfo} = useSelector((state: AppState) => ({
        userInfo: state.user.userInfo
    }));



    const [showMenu, setShowMenu] = useState<boolean>(false);
    const allProgramListQueryKey = useMemo(() => ["/api/getAllProgram",{
        params:{userId:userInfo?.id}
    }], [userInfo?.id]);
    const {data:allProgramList = []} = useQuery<ProgramDetail[]>({
        queryKey: allProgramListQueryKey,
        enabled:  !!userInfo?.id
    });



    const handleOuterClick = useCallback(() => {
        setShowMenu(false);
        document.removeEventListener("click", handleOuterClick);
    }, []);

    const handleMenuIcon = useCallback((toSet: boolean) => () => {
        document.dispatchEvent(new Event("click"));
        setShowMenu(toSet);

        if (toSet) {
            document.addEventListener("click", handleOuterClick);
        } else {
            document.removeEventListener("click", handleOuterClick);
        }
    }, [setShowMenu, handleOuterClick]);

    const handlePropagation = useCallback((event: React.MouseEvent) => {
        event.nativeEvent.stopImmediatePropagation();
    }, []);

    const [isLimitRecommendVideos, ChangeLimitRecommendVideos] = React.useState(false);
    // const [recommendVideoNum, ChangeRecommendVideoNum] = React.useState(0);
    const [isDuplicatedRec, setIsDuplicatedRec] = React.useState(false);


    const CloseLimitRecommendVideoBar = () => {
        ChangeLimitRecommendVideos(false);
    };
    const CloseDuplicateRecommendVideoBar = () => {
        setIsDuplicatedRec(false);
    };

    const [isDuplicatedEpisode, setIsDuplicatedEpisode] = React.useState(false);
    const [isDuplicatedRelateVideo, setIsDuplicatedRelateVideo] = React.useState(false);
    function addVideoToChannel(programId: string, videoType: number) {
        if (!userInfo) return;
        ProgramApi.AddVideoToProgram(userInfo.id, programId, videoId.toString(), videoType).then((res) => {
            queryClient.setQueryData<ProgramDetail[]>(allProgramListQueryKey,(currentData) => {
                return currentData?.map((program) => {
                    if (program.id === res.id) {
                        return res;
                    } else {
                        return program;
                    }
                });
            });
        });
    }
    const handleAddToProgram = (title: string, id: string) => {
        setShowMenu(false);
        console.log("handleAddToProgram:",title,id);
        if (title.includes("episode")) {
            const targetVideos = allProgramList.find((pro) => {
                return pro.id === id;
            });
            const dupVideo = targetVideos?.videos.find((el) => {
                return el.id.toString() === videoId.toString();
            });
            if(userInfo && !dupVideo) {
                setMsg(title.replaceAll("episode", "エピソード"));
                addVideoToChannel(id, 1);
            } else {
                setIsDuplicatedEpisode(true);
            }
        } else if (title.includes("relationVideo")) {
            const targetVideos = allProgramList.find((pro) => {
                return pro.id === id;
            });
            const dupRelatedVideo = targetVideos?.relatedVideos.find((el) => {
                return el.id.toString() === videoId.toString();
            });
            if(userInfo && !dupRelatedVideo) {
                setMsg(title.replaceAll("relationVideo", "関連するVideo"));
                addVideoToChannel(id, 2);
            } else {
                setIsDuplicatedRelateVideo(true);
            }
        }
    };

    const CloseDuplicatedEpisodeBar = () => {
        setIsDuplicatedEpisode(false);
    };
    const CloseDuplicatedRelatedBar = () => {
        setIsDuplicatedRelateVideo(false);
    };

    const [isDuplicated, setIsDuplicated] = React.useState(false);



    const CloseDuplicatedProjectBar = () => {
        setIsDuplicated(false);
    };

    return (
        <div className={styles.menuArea} onClick={handlePropagation}>
            <Fab
                variant="circular"
                size="small"
                className={classes.icon}
                onClick={handleMenuIcon(!showMenu)}
            >
                <PlaylistAddIcon style={{color: "var(--red)"}}/>
            </Fab>

            <Menu className={showMenu ? styles.menu : styles.nomenu} selectable={false}>
                <SubMenu title="Channel" key="Program">
                    {
                        allProgramList.length > 0 &&
                                allProgramList.map((item) => (
                                    <SubMenu title={item.title} key={item.id}>
                                        <MenuItem
                                            key={`Program-${item.id}-episode`}
                                            onClick={() => handleAddToProgram(`Program-${item.title}-episode`, item.id)}
                                        >
                                            エピソード
                                        </MenuItem>
                                        <MenuItem
                                            key={`Program-${item.id}-relationVideo`}
                                            onClick={
                                                () => handleAddToProgram(`Program-${item.title}-relationVideo`, item.id)
                                            }
                                        >
                                            関連するVideo
                                        </MenuItem>
                                    </SubMenu>
                                ))
                    }
                    {
                        allProgramList.length === 0 &&
                                <MenuItem key="noProgramData" disabled>
                                    Channelがありません。
                                </MenuItem>
                    }
                </SubMenu>
            </Menu>

            <PuiMessage
                open={isLimitRecommendVideos}
                type= "error"
                title= "おすすめVideoは、すでに10件登録されているので追加できません"
                duration= {5000}
                onClose={CloseLimitRecommendVideoBar}
            />
            <PuiMessage
                open={isDuplicatedRec}
                type= "error"
                title= "このVideoは既におすすめVideoに登録されています"
                duration= {5000}
                onClose={CloseDuplicateRecommendVideoBar}
            />
            <PuiMessage
                open={isDuplicatedEpisode}
                type= "error"
                title= "このVideoは既に選択したChannelのエピソードに登録されています"
                duration= {5000}
                onClose={CloseDuplicatedEpisodeBar}
            />
            <PuiMessage
                open={isDuplicatedRelateVideo}
                type= "error"
                title= "このVideoは既に選択したChannelの関連Videoに登録されています"
                duration= {5000}
                onClose={CloseDuplicatedRelatedBar}
            />
            <PuiMessage
                open={isDuplicated}
                type= "error"
                title= "このVideoは既に選択したProjectに登録されています"
                duration= {5000}
                onClose={CloseDuplicatedProjectBar}
            />
        </div>
    );
}

function VideoMenuAuth({video,setMsg}:{
    video:Video,
    setMsg: (msg: string) => void
}) {
    const {isDesktop} = useResponsive();
    const userInfo = useSelector((state: AppState) => state.user.userInfo);
    const isShowChangeMenu = isDesktop && (isAdmin(userInfo?.roles) ||
    (isPresenter(userInfo?.roles) && userInfo?.id === video.presenterId));
    return isShowChangeMenu ? <VideoMenu videoId={video.id} setMsg={setMsg}/> : null;
}

export default memo(VideoMenuAuth);
